import React from 'react';
import './index.scss';
import { Popover } from 'tea-component';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';

// Mixed，Positive，Negative
export const barType = {
  mixed: 0,
  positive: 1,
  negative: -1,
};
const NewDetailBar = (props) => {
  let { data = {}, clickName } = props;
  if (!Object.keys(data)?.length) {
    return <></>
  }
  return (
    <div
      className={`dbi-new-detailBar ${
        /*data?.barType == barType.mixed
          ? 'dbi-detailBar-col'
          : */data?.barType == barType.negative
          ? 'dbi-detailBar-negative'
          : ''
      }`}
    >
      {data?.title && (
        <div className="dbi-new-detailBar-title">
          {data?.title}
          {data?.titleTip && (
            <TipContext
              tipText={data?.titleTip}
              className="dbi-new-detailBar-title-icon"
            />
          )}
        </div>
      )}
      <div className="dbi-new-detailBar-header">
        {data?.headerList?.map((item, index) => {
          return (
            <div className="dbi-new-detailBar-td" key={index}>
              {item}
            </div>
          );
        })}
      </div>
      <div
        className={`dbi-new-detailBar-body ${
          data?.list?.length > 5 ? 'dbi-new-detailBar-stretch' : ''
        }`}
      >
        {data?.list?.map((item, index) => {
          return <TrItem key={index} item={item} data={data} clickName={clickName} />;
        })}
      </div>
    </div>
  );
};

export default NewDetailBar;

const TrItem = (props) => {
  let { item, data, clickName } = props;
  return JSON.stringify(item) === '{}' ? (
    <div className={`dbi-new-detailBar-tr`}></div>
  ) : (
    <div className="dbi-new-detailBar-tr">
      <Popover
        placement="right"
        overlay={<HoverBubble data={item} header={data?.headerList} />}
      >
        <div className="dbi-new-detailBar-th">
          <span
            className={clickName instanceof Function ? 'dbi-new-detailBar-hover' : ''}
            onClick={() => {
              if (clickName instanceof Function) {
                clickName(item)
              }
            }}>
              {item?.name}
          </span>
        </div>
      </Popover>
      <div className="dbi-new-detailBar-th">
        <TextBox
          dataObj={item?.barLeft}
          data={item}
          header={data?.headerList}
        />
      </div>
      <div className="dbi-new-detailBar-th">
          <TextBox
            dataObj={Object.keys(item?.barRightPositive).length ?item?.barRightPositive : item?.barRightNegative}
            data={item}
            header={data?.headerList}
          />
        {/* {data?.barType == barType.mixed ? (
          <div className="dbi-new-detailBar-flex">
            <TextBox
              dataObj={item?.barRightPositive}
              data={item}
              header={data?.headerList}
            />
            <TextBox
              dataObj={item?.barRightNegative}
              data={item}
              header={data?.headerList}
            />
          </div>
        ) : null}
        {data?.barType == barType.positive ? (
          <TextBox
            dataObj={item?.barRightPositive}
            data={item}
            header={data?.headerList}
          />
        ) : null}
        {data?.barType == barType.negative ? (
          <TextBox
            dataObj={item?.barRightNegative}
            data={item}
            header={data?.headerList}
          />
        ) : null} */}
      </div>
    </div>
  );
};

const TextBox = (props) => {
  let { data, dataObj, header } = props;
  return (
    <Popover
      // trigger="click"
      placement="right"
      overlay={<HoverBubble data={data} header={header} />}
    >
      <div className="dbi-detailBar-width">
        <div
          className="dbi-detailBar-width-bg"
          style={{ width: dataObj?.width, backgroundColor: dataObj?.color }}
        />
        <span className="dbi-detailBar-width-text">{dataObj?.text}</span>
      </div>
    </Popover>
  );
};

// 跟鼠标移动气泡
const HoverBubble = (props) => {
  let { data, header } = props;
  return (
    <div className="dbi-hover-bubble">
      {header?.map((item, index) => {
        return (
          <div className="dbi-hover-bubble-newitem" key={index}>
            <div className="dbi-hover-bubble-newtitle">{item}</div>
            <div className="dbi-hover-bubble-newtext">
              {index == 0
                ? data?.name
                : index == 1
                ? data?.barLeft?.text
                : data?.barRightNegative?.text || data?.barRightPositive?.text}
            </div>
          </div>
        );
      })}
      {/* <div className="dbi-hover-bubble-heard">
        {header?.map((item, index) => {
          return (
            <div key={index} className="dbi-hover-bubble-td">
              {item}
            </div>
          );
        })}
      </div>
      <div className="dbi-hover-bubble-tr">
        <div className="dbi-hover-bubble-th">{data?.name}</div>
        <div className="dbi-hover-bubble-th">{data?.barLeft.text}</div>
        <div className="dbi-hover-bubble-th">
          {data?.barRightNegative.text || data?.barRightPositive.text}
        </div>
      </div> */}
    </div>
  );
};
